import { requestWithAuth } from './config';

const resource = '/statistics/systems';

export const getAll = () => {
  return requestWithAuth.get(resource);
};
